function c() {
  function n(t) {
    return new Promise((r) => {
      let e = new XMLHttpRequest();
      e.open(t.method, t.url, !0), Object.keys(t.headers).forEach((s) => e.setRequestHeader(s, t.headers[s]));
      let a = (s, i) => setTimeout(() => {
        e.abort(), r({ status: 0, content: i, isTimedOut: !0 });
      }, s), u = a(t.connectTimeout, "Connection timeout"), o;
      e.onreadystatechange = () => {
        e.readyState > e.OPENED && o === void 0 && (clearTimeout(u), o = a(t.responseTimeout, "Socket timeout"));
      }, e.onerror = () => {
        e.status === 0 && (clearTimeout(u), clearTimeout(o), r({ content: e.responseText || "Network request failed", status: e.status, isTimedOut: !1 }));
      }, e.onload = () => {
        clearTimeout(u), clearTimeout(o), r({ content: e.responseText, status: e.status, isTimedOut: !1 });
      }, e.send(t.data);
    });
  }
  return { send: n };
}
export {
  c as createXhrRequester
};
//# sourceMappingURL=help-center-articles-search48.js.map
